import { ActionButtonTheme } from '../../types';

export const ACTION_BUTTON_DEFAULT_THEME: ActionButtonTheme = {
    hoverOpacity: 0.15,
    labelSize: 'm',
    labelWeight: 'semiBold',
    borderRadius: 8,
    colors: {
        primary: {
            content: 'primary.base',
            hoverBackground: 'grey.base',
        },
        secondary: {
            content: 'secondary.base',
            hoverBackground: 'grey.base',
        },
        tertiary: {
            content: 'accent.base',
            hoverBackground: 'grey.base',
        },
    },
    fixedColors: {
        neutral: {
            content: 'grey.base',
            hoverBackground: 'grey.base',
        },
        white: {
            content: 'common.white',
            hoverBackground: 'common.white',
        },
    },
};
